import { useContext } from 'react';
import { ConfigContext } from '@/context';
import { ComplianceRequestCreate } from './ComplianceRequestCreate';

type Props = {
  onCancel: () => void;
  onSubmit: () => void;
};

export function ComplianceRequestDoNotSell({ onCancel, onSubmit }: Props) {
  const {
    doNotSellRequestName,
    doNotSellRequestDescription,
    privacyRequestsRequestsText,
  } = useContext(ConfigContext);

  return (
    <ComplianceRequestCreate
      description={doNotSellRequestDescription}
      placeholder={privacyRequestsRequestsText}
      requestType="do_not_sell"
      title={doNotSellRequestName}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
}
